import { render } from "./product-faqs-accordion.vue?vue&type=template&id=c333a154"
import script from "./product-faqs-accordion.vue?vue&type=script&lang=js"
export * from "./product-faqs-accordion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__